/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Accessories(props) {
    return (
        <SvgIcon {...props}>
            <path d="M12.786,3.517C12.158,2.183,10.355,2.017,9.784,2C9.773,2,9.739,2,9.688,2c-0.04,0-0.074,0-0.085,0 C9.315,2.011,8.727,2.056,8.128,2.267s-1.21,0.583-1.526,1.25C6.381,3.989,6.336,4.544,6.455,5.183 C5.974,5.127,5.46,5.094,4.917,5.094c-1.96,0-3.721,0.396-4.498,0.969c0.382,0.47,1.462,1.159,4.545,1.249 c3.037-0.089,4.131-0.759,4.528-1.229c-0.539-0.375-1.51-0.676-2.598-0.844C6.738,4.544,6.805,4.05,6.975,3.694 c0.577-1.222,2.459-1.277,2.753-1.277c0.452,0.005,2.143,0.127,2.685,1.277c0.418,0.883,0.261,2.678-2.718,6.223 C9.507,9.688,9.327,9.473,9.163,9.261c0.339-0.223,0.774-0.472,0.774-0.739c0-0.022,0-1.784,0-1.806 c0-0.023-0.006-0.046-0.009-0.069c-0.831,0.809-2.486,1.256-4.92,1.33l0,0.004c-0.014,0-0.027-0.001-0.042-0.002 c-0.015,0-0.028,0.002-0.043,0.002l0-0.004C2.492,7.904,0.84,7.458,0.007,6.652C0.006,6.665,0,6.676,0,6.689c0,0,0,1.822,0,1.833 c0,0.889,2.278,1.616,4.918,1.616c1.599,0,3.007-0.267,3.877-0.677c0.204,0.261,0.413,0.522,0.645,0.789L8.693,11l1,1l1-1 l-0.746-0.75C12.509,7.228,13.47,4.961,12.786,3.517z M5.873,9.617c-0.13,0.006-0.819,0.011-0.955,0.011 c-0.13,0-0.26-0.005-0.39-0.011v-1.3c0.13,0.006,0.26,0.011,0.39,0.011c0.136,0,0.825-0.005,0.955-0.011V9.617z" />
        </SvgIcon>
    );
}

Accessories.defaultProps = {
    viewBox: '0 0 13 16'
};

export default Accessories;
